<form class="form" novalidate="" (ngSubmit)="onSubmit()" #f="ngForm">




  <div class="label-healins">Emergency Contact(Family)</div>
  <div class="row">
    <div class="col-md-12 padding-l-0px">
      <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12 my-profile-form padding-lr-0px">
        <div class="card-header wh-header card-header-bg padding-left-7px padding-top-6px margin-top-10">
          General
          <button type="submit" [disabled]="!f.valid" *ngIf='!isRequesting' class="btn actions-btn-prime float-right">Save</button>

        </div>
        <div class="card-body card-body-general">
          <div class="row">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-3 text-align-right">
                  <label for="firstName"><span>*</span> Name </label>
                </div>
                <div class="col-md-3">

                  <input type="text" class="form-control" id="CurrentActorPersonalDetailInfoRequest.FirstName"
                         [(ngModel)]="CurrentActorPersonalDetailInfoRequest.FirstName"
                         name="CurrentActorPersonalDetailInfoRequest.FirstName" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                         placeholder="First Name" maxlength="20" minlength="1" #FirstName="ngModel" required>
                  <small class="form-text text-danger"
                         *ngIf="(!FirstName.valid && (FirstName.dirty || FirstName.touched) && FirstName.errors.required )">(Field cannot be left blank)</small>
                  <small class="form-text text-danger"
                         *ngIf="(!FirstName.valid && FirstName.errors.pattern)">(special characters are not allowed)</small>

                </div>
                <div class="col-md-3">

                  <input type="text" class="form-control" id="CurrentActorPersonalDetailInfoRequest.MiddleName"
                         [(ngModel)]="CurrentActorPersonalDetailInfoRequest.MiddleName"
                         name="CurrentActorPersonalDetailInfoRequest.MiddleName"
                         placeholder="Middle Name" maxlength="20" pattern="^[\sa-zA-Z0-9,._\-?]*$" #MiddleName="ngModel" required>
                  <small class="form-text text-danger"
                         *ngIf="(!MiddleName.valid && MiddleName.errors.pattern)">(special characters are not allowed)</small>

                </div>
                <div class="col-md-3">


                  <input type="text" class="form-control" id="CurrentActorPersonalDetailInfoRequest.LastName"
                         [(ngModel)]="CurrentActorPersonalDetailInfoRequest.LastName"
                         name="CurrentActorPersonalDetailInfoRequest.LastName"
                         placeholder="Last Name" required maxlength="20" minlength="1" #LastName="ngModel" pattern="^[\sa-zA-Z0-9,._\-?]*$">
                  <small class="form-text text-danger"
                         *ngIf="(!LastName.valid && (LastName.dirty || LastName.touched) && LastName.errors.required)">(Field cannot be left blank)</small>
                  <small class="form-text text-danger"
                         *ngIf="(!LastName.valid && LastName.errors.pattern)">(special characters are not allowed)</small>

                </div>
              </div>

            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-3 text-align-right">
                  <label for="diaplayName"><span>*</span> Relationship</label>
                </div>

                <div class="col-md-3">
                  <CodeTypeValue CodeType="MARTL">
                    <!--id="CurrentActorPersonalDetailInfoRequest.MaritalStatus"
          [(ngModel)]="CurrentActorPersonalDetailInfoRequest.MaritalStatus" SelectedValue="{{CurrentActorPersonalDetailInfoRequest.MaritalStatus}}"
          name="CurrentActorPersonalDetailInfoRequest.MaritalStatus"-->
                  </CodeTypeValue>

                </div>
              </div>


            </div>
          </div>

        </div>
      </div>
    </div>



    <div class="col-md-12 padding-l-0px">
      <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12 my-profile-form padding-lr-0px">
        <div class="card-header wh-header card-header-bg padding-left-7px padding-top-6px margin-top-10">
          Contact
          <button type="submit" [disabled]="!f.valid" *ngIf='!isRequesting' class="btn actions-btn-prime float-right">Save</button>
        </div>
        <div class="card-body card-body-general">
          <!--<div class="row">
            <div class="col-md-3 text-align-right">
              <label for="diaplayName"><span>*</span> Mobile Phone </label>
            </div>
            <div class="col-md-3">
              <input type="tel" class="form-control" id="CurrentActorPersonalDetailInfoRequest.Telephone1"
                     [(ngModel)]="CurrentActorPersonalDetailInfoRequest.Telephone1"
                     mask="(000) 000-0000"
                     name="CurrentActorPersonalDetailInfoRequest.Telephone1" pattern="[0-9]{10}" #Telephone1="ngModel"
                     placeholder="Mobile Phone" />
              <small class="form-text text-danger"
                     *ngIf="(!Telephone1.valid)">(Provide Valid CellNo)</small>
            </div>
          </div>-->
          <div class="row">
    <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
      <div class="row">
        <div class="col-md-3 text-align-right">
          <label for="diaplayName"><span>*</span> Mobile Phone </label>
        </div>
        <div class="col-md-3">
          <input type="tel" class="form-control" id="CurrentActorPersonalDetailInfoRequest.Telephone2"
                 [(ngModel)]="CurrentActorPersonalDetailInfoRequest.Telephone2"
                 mask="(000) 000-0000"
                 name="CurrentActorPersonalDetailInfoRequest.Telephone2" pattern="[0-9]{10}" #Telephone2="ngModel"
                 placeholder="Telephone" />
          <small class="form-text text-danger"
                 *ngIf="(!Telephone2.valid)">(Provide Valid Phone No)</small>
        </div>
      </div>


    </div>
  </div>
          <div class="row">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">

                <div class="col-md-3 text-align-right">
                  <label for="email address"><span>*</span> Email Address  </label>
                </div>
                <div class="col-md-4">
                  <input type="email" class="form-control" id="CurrentActorPersonalDetailInfoRequest.Email"
                         [(ngModel)]="CurrentActorPersonalDetailInfoRequest.Email"
                         name="CurrentActorPersonalDetailInfoRequest.Email"
                         placeholder="Email" required pattern="[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,3}$"
                         #Email="ngModel" maxlength="30" minlength="4">
                  <small class="form-text text-danger"
                         *ngIf="(!Email.valid && (Email.dirty || Email.touched)  && Email.errors.required)">(Provide Valid Email)</small>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

    </div>
  </div>
  <div class="label-healins">Emergency Contact(Hospital)</div>
  <div class="row">
    <div class="col-md-12 padding-l-0px">
      <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12 my-profile-form padding-lr-0px">
        <div class="card-header wh-header card-header-bg padding-left-7px padding-top-6px margin-top-10">
          General
          <button type="submit" [disabled]="!f.valid" *ngIf='!isRequesting' class="btn actions-btn-prime float-right">Save</button>

        </div>
        <div class="card-body card-body-general">
          <div class="row">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-3 text-align-right">
                  <label for="firstName"> Name</label>
                </div>
                <div class="col-md-5">

                  <input type="text" class="form-control" id="CurrentActorPersonalDetailInfoRequest.FirstName"
                         [(ngModel)]="CurrentActorPersonalDetailInfoRequest.FirstName"
                         name="CurrentActorPersonalDetailInfoRequest.FirstName" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                         placeholder="Hospital Name" maxlength="20" minlength="1" #FirstName="ngModel" required>
                  <small class="form-text text-danger"
                         *ngIf="(!FirstName.valid && (FirstName.dirty || FirstName.touched) && FirstName.errors.required )">(Field cannot be left blank)</small>
                  <small class="form-text text-danger"
                         *ngIf="(!FirstName.valid && FirstName.errors.pattern)">(special characters are not allowed)</small>
                 

                </div>

              </div>

            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-3 text-align-right ">
                  <label for="diaplayName">Location </label>
                </div>
                <div class="col-md-3 ">
                  <input type="text" class="form-control" id="CurrentActorPersonalDetailInfoRequest.City"
                         [(ngModel)]="CurrentActorPersonalDetailInfoRequest.City"
                         name="CurrentActorPersonalDetailInfoRequest.City"
                         placeholder="Location" maxlength="50" pattern="^[\sa-zA-Z0-9,._\-?]*$" #City="ngModel" />
                  <small class="form-text text-danger"
                         *ngIf="(!City.valid && City.errors.pattern)">(special characters are not allowed)</small>
                  <!--<label>Hyderabad</label>-->
                </div>
              </div>


            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-3  text-align-right">
                  <label for="diaplayName"> Contact </label>
                </div>
                <div class="col-md-3 ">
                  <input type="tel" class="form-control" id="CurrentActorPersonalDetailInfoRequest.Telephone1"
                         [(ngModel)]="CurrentActorPersonalDetailInfoRequest.Telephone1"
                         mask="(000) 000-0000"
                         name="CurrentActorPersonalDetailInfoRequest.Telephone1" pattern="[0-9]{10}" #Telephone1="ngModel"
                         placeholder="Contact " />
                  <small class="form-text text-danger"
                         *ngIf="(!Telephone1.valid)">(Provide Valid CellNo)</small>
                  <!--<label>8106220988</label>-->
                </div>
              </div>


            </div>
          </div>

        </div>
      </div>
    </div>
  </div>

</form>

